import { Box, Button, Center, Group, Text, Textarea } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { repositoryPos } from "../../_base/_const/_constVar";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { useState } from "react";

interface MessageResponse<T> {
  success: boolean;
  data: T;
}

interface OrderStatus {
  id: number;
  code: string;
  description: string;
  active: boolean;
  createDate: string;
  createBy: number;
  lastUpdateDate: string | null;
  lastUpdateBy: number | null;
}

interface DeleteProduct {
  idItems: number[];
  onSearch: () => void;
  onClose: any;
  status: OrderStatus;
  web?: boolean;
}

const SalesDeleteOrder = ({
  idItems,
  onSearch,
  onClose,
  status,
  web,
}: DeleteProduct) => {
  const [dataReason, setDataReason] = useState<string>("");

  //   const [listStatus, setListStatus] = useState<OrderStatus[] | undefined>();
  //   const getStatus = async () => {
  //     const res = await repositoryPos.get<MessageResponse<OrderStatus[]>>(
  //       "/api/v1/OrderStatus/get-all"
  //     );
  //     if (res?.success) {
  //       setListStatus(res?.data);
  //     }
  //     modals.closeAll();
  //     onSearch();
  //   };

  //   console.log(listStatus);

  const handleDeleteOrderWeb = async () => {
    if (dataReason?.trim()?.length > 1) {
      const res = await repositoryPos.post<MessageResponse<boolean>>(
        `/api/v1/CreateSellItem/cancel`,
        { orderNumber: idItems, reason: dataReason }
      );

      if (res?.success) {
        NotificationExtension.Success("Hủy thành công !");

        // Đợi 500ms trước khi gọi onSearch và onClose
        setTimeout(() => {
          onSearch();
          onClose((prev: any) => !prev);
        }, 1000);
      } else {
        NotificationExtension.Fails("Hủy thất bại !");
      }

      modals.closeAll();
    } else {
      NotificationExtension.Fails("Vui lòng nhập lí do hủy đơn hàng !");
    }
  };

  const handleDeleteOrder = async () => {
    const res = await repositoryPos.get<MessageResponse<boolean>>(
      `/api/v1/CreateSellItem/delete?orderNumber=${idItems}`
    );

    if (res?.success) {
      NotificationExtension.Success("Hủy thành công !");

      // Đợi 500ms trước khi gọi onSearch và onClose
      setTimeout(() => {
        onSearch();
        onClose((prev: any) => !prev);
      }, 1000);
    } else {
      NotificationExtension.Fails("Hủy thất bại !");
    }

    modals.closeAll();
  };

  //   useEffect(() => {
  //     getStatus();
  //   }, []);

  return (
    <Box size={"auto"} w={"32.5vw"}>
      {web ? (
        <Textarea
          mt={5}
          label="Lí do hủy đơn"
          placeholder="Lí do hủy đơn (Nhập ít nhất 2 kí tự)"
          value={dataReason}
          onChange={(e) => setDataReason(e.currentTarget.value)}
          withAsterisk
        />
      ) : (
        <Center>
          <Text fw={700} size="xl" mt={5}>
            Bạn có chắc chắn muốn hủy đơn hàng này ?
          </Text>
        </Center>
      )}

      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="gray"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Thoát
        </Button>
        <Button
          type="button"
          color="red"
          onClick={() => {
            if (web) {
              handleDeleteOrderWeb();
            } else {
              handleDeleteOrder();
            }
          }}
          leftSection={<IconCheck size={18} />}
        >
          Xác nhận
        </Button>
      </Group>
    </Box>
  );
};

export default SalesDeleteOrder;
